<template>
	<div class="class-making-box clearfix">
		<h3 class="f-18 text-nomal">강좌 목표 및 강좌 내용</h3>
		<div class="white-box clearfix">
			<p class="f-14">
				강좌 목표
			</p>
			<div class="round on-border">
				<input class="half-width form-control-sm m-b-0 no-border text-left pull-left" type="text" placeholder="강의목표 입력" v-model="data.goal">
				<span class="pull-right m-r-5 text-lightgray">{{data.goal.length}} / 30</span>
			</div>
		</div>
		<div class="white-box clearfix">
			<p class="f-14 m-b-5">
				강좌 내용
			</p>
			<div class="round">
				<textarea class="full-width editorContent" cols="30" rows="4"></textarea>
			</div>
		</div>

		<!-- button wrapper -->
		<!-- <button class="btn btn-red round m-t-30 pull-left" type="button" @click="setInitValue">초기값으로 설정</button> -->
		<button class="btn bg-deepblue text-white round m-t-30 pull-right" type="button" @click="nextStep">저장하고 넘어가기</button>
		<button class="btn round m-t-30 m-r-5 pull-right" type="button" @click="skipStep">건너뛰기</button>
	</div>
</template>

<script>
import fnTextEditor from '../../mixins/fnTextEditor'

export default {
	name: "SubviewClassRegisterStep_2",
	mixins: [fnTextEditor],
	data: function() {
		return {
			data: {
				goal: this.classData.goal,
				content: this.classData.content
			},
			editorContent: null
		}
	},
	props: {
		classData: Object,
		default: Object
	},
	mounted: function() {
		this.initEditor({
			selector:'.editorContent', 
			contentName:'content',
			editorContentName: 'editorContent'
		});
	},
	methods: {
		setInitValue: function() {
			this.data.goal = this.default.goal;
			this.data.content = this.default.content;
			this.editorContent.html.set(this.data.content);
		},
		skipStep: function() {
			this.$emit("skipStep", {});
		},
		nextStep: function() {
			if(!this.data.goal) {
				this.$emit("alert", "강의목표를 입력하세요.");
				return;
			}
			if(!this.data.content) {
				this.$emit("alert", "강의내용을 입력하세요.");
				return;
			}
			this.$emit("nextStep", this.data);
		}
	}
}
</script>

<style scoped>
</style>